import { type Competition } from '@app/client/common/structs';
import { compare } from '@app/helpers';

export function mapAlphaGameData(comp) {
    const starts_at = comp.game_details.start_at;
    const submission_ends_at = starts_at;
    const ends_at = comp.game_details.end_at;
    return {
        dynamic_criteria: [],
        game_label: `Game #${comp.game_details.game_num}`,
        id: `${comp.game_details.id}`,
        max_assets: 500,
        max_value: 100000,
        starts_at,
        ends_at,
        submission_ends_at,
        name: comp.game_details.title,
        slug: `${comp.game_details.game_num}`,
        header_images: [comp.game_details.game_image_url || ''],
        prizes: comp.game_details.total_prize_pool_usd
            ? [
                  {
                      description: 'Prize pool',
                      name: 'Price Pool',
                      rank: 1,
                      reward: `$${comp.game_details.total_prize_pool_usd}`,
                  },
              ]
            : undefined,
    };
}

export function sortGamesBySubmissionEnd(games: Competition[]) {
    const now = new Date().getTime();
    const alreadySubmitted = (game: Competition) => !!game?.wishlists?.length;
    const alreadyStarted = (game: Competition) => new Date(game?.submission_ends_at || '0').getTime() < now;

    return games?.sort((a, b) => {
        const time = compare(a.submission_ends_at, b.submission_ends_at);
        if (alreadyStarted(a)) {
            return alreadyStarted(b) ? time : 1;
        }
        if (!alreadyStarted(a) && alreadyStarted(b)) {
            return -1;
        }
        if (alreadySubmitted(a)) {
            return alreadySubmitted(b) ? time : 1;
        }
        if (!alreadySubmitted(a) && alreadySubmitted(b)) {
            return -1;
        }
        return time;
    });
}
